import { styled } from '@uhg-abyss/web/tools/styled';
import React, { ReactNode, useEffect, useState } from 'react';

import { LagoonContext } from '../hooks/useLagoon/LagoonContext';
import { lagoon } from './lagoonUtil';
import { useLanguage } from '../components/Language/LanguageProvider';

const LagoonLoader = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  height: '90vh',
});

export interface Props {
  app: string;
  lob: string;
  env: string;
  hostEnv?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user?: any;
  timeout?: number;
  loadingIcon?: ReactNode;
  children?: React.ReactNode;
}

export const LagoonProvider = ({
  app,
  lob,
  env,
  hostEnv,
  user,
  timeout,
  loadingIcon,
  children,
  ...props
}: Props) => {
  const [lagoonInstance, setLagoonInstance] = useState({});
  const { locale } = useLanguage();

  useEffect(() => {
    const fallbackLoadTimeout = setTimeout(() => {
      setLagoonInstance((prevState) => prevState || {});
    }, timeout);
    lagoon(app, lob, env, hostEnv, locale.code).initialize(user, {
      onReady: () => {
        clearTimeout(fallbackLoadTimeout);
      },
      onData: (instance) => {
        setLagoonInstance(instance);
      },
    });
  }, [app, env, user, hostEnv, timeout, locale, lob]);
  if (!Object.keys(lagoonInstance).length) {
    if (loadingIcon) {
      return <LagoonLoader>{loadingIcon}</LagoonLoader>;
    }
    return null;
  }

  return (
    <LagoonContext.Provider {...props} value={lagoonInstance}>
      {children}
    </LagoonContext.Provider>
  );
};

LagoonProvider.displayName = 'search-container/ui/LagoonProvider';
